import React from "react"
import { ButtonLoadingSeeker } from "@ui-seeker/core"

import { useUserSettingsWebSupplierGroup, useUserSettingsWebSupplierGroupValidator } from "../../@hooks"


export default function WebSupplierGroupDrawerSubmit() {
	const { isLoading, handleSubmitFormData } = useUserSettingsWebSupplierGroup()
	const { isValid } = useUserSettingsWebSupplierGroupValidator()

	return <ButtonLoadingSeeker
		loading={isLoading}
		disabled={!isValid}
		onClick={handleSubmitFormData}
	>
		Save
	</ButtonLoadingSeeker>
}